module.exports = __webpack_public_path__ + "img/KM-360A_03.c6b49f9e.jpg";